import React, { Suspense, lazy } from 'react'
import { isMobile, MobileView, BrowserView } from 'react-device-detect'
import { Dialog, Container } from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import CircledPopUpFrame from '../Core/CircledPopUpFrame'
import { BackButtonTitle } from '../Core/BackButtonTitle'
const SideMenu = lazy(() => import('../SideMenu/SideMenu'))

interface SkywatchDialogProps {
    open: Boolean;
    closeDialog: Function;
    children: any;
    closeTitle: String;
    circleHeader: any;
    maxWidth: String;
    fullWidth: Boolean;
    excludeCloseIcon:Boolean
}

export const SkywatchDialog = ({
    open,
    closeDialog,
    children,
    circleHeader,
    closeTitle,
    maxWidth = 'md',
    fullWidth = true,
    excludeCloseIcon,
    ...props
}: SkywatchDialogProps) => {
    return (
        <Dialog
            BackdropProps={{
                style: {
                    backgroundColor: 'white',
                    opacity: isMobile ? 1 : 0.64,
                },
            }}
            fullWidth={fullWidth}
            fullScreen={isMobile}
            open={open}
            onClose={closeDialog}
            PaperProps={{
                style: { backgroundColor: 'transparent', boxShadow: 'none' },
            }}
            maxWidth={maxWidth}
        >
            <MobileView>
                <Suspense fallback={<div />}>
                    <SideMenu />
                </Suspense>
                <Container>
                    <BackButtonTitle
                        onBackPressed={closeDialog}
                        title={closeTitle}
                    />
                    <br />
                    {children}
                </Container>
            </MobileView>
            <BrowserView>
                <CircledPopUpFrame
                excludeCloseIcon={excludeCloseIcon}
                    onCancel={closeDialog}
                    circleHeader={circleHeader}
                >
                    {children}
                </CircledPopUpFrame>
            </BrowserView>
        </Dialog>
    )
}
